import {
    CashReceiptIssueType, CreateOrderRequest, OrderType, PaymentMethod,
} from '@models/order';
import { PayloadAction, WritableDraft } from '@reduxjs/toolkit';

export const setNote = (state: WritableDraft<CreateOrderRequest>, action: PayloadAction<string>) => {
    state.note = action.payload;
};

export const setPaymentMethod = (state: WritableDraft<CreateOrderRequest>, action: PayloadAction<PaymentMethod>) => {
    state.paymentMethod = action.payload;
    // 간편카드가 아닌 수단으로 바꾸면 골라 둔 간편카드는 비운다
    if (action.payload !== 'EASY_CARD') {
        state.easyCardId = undefined;
    }
};

export const setOrderType = (state: WritableDraft<CreateOrderRequest>, action: PayloadAction<OrderType>) => {
    state.orderType = action.payload;
};

export function setName(state: WritableDraft<CreateOrderRequest>, action: PayloadAction<string>) {
    state.easyCardName = action.payload;
}

export function setEasyCardId(state: WritableDraft<CreateOrderRequest>, action: PayloadAction<string | undefined>) {
    state.easyCardId = action.payload;
}

export function setSaveNote(
    state: WritableDraft<CreateOrderRequest>,
    action: PayloadAction<boolean>,
) {
    state.saveNote = action.payload;
}

export function setSavePaymentMethod(
    state: WritableDraft<CreateOrderRequest>,
    action: PayloadAction<boolean>,
) {
    state.savePaymentMethod = action.payload;
}

export function setSaveCashReceipt(
    state: WritableDraft<CreateOrderRequest>,
    action: PayloadAction<boolean>,
) {
    state.saveCashReceipt = action.payload;
}

export function setUseEmployeeDiscount(
    state: WritableDraft<CreateOrderRequest>,
    action: PayloadAction<boolean>,
) {
    state.useEmployeeDiscount = action.payload;
}

/** 신청으로 바꿀 때 저장해 둔 현금영수증 정보가 있으면 불러온다 */
export function enableCashReceipt(state: WritableDraft<CreateOrderRequest>) {
    const saved = getSavedCashReceipt();
    state.cashReceipt = saved || {
        issueNumber: '',
        issueType: 'PERSONAL',
    };
    state.saveCashReceipt = !!saved;
}

/** 저장해 둔 현금영수증 정보가 있을 때만 신청 상태로 바꾼다 */
export function applySavedCashReceipt(state: WritableDraft<CreateOrderRequest>) {
    const saved = getSavedCashReceipt();
    if (saved) {
        state.cashReceipt = saved;
        state.saveCashReceipt = true;
    }
}

function getSavedCashReceipt(): CreateOrderRequest['cashReceipt'] {
    try {
        const value = window.localStorage.getItem('cashReceipt');
        return value ? JSON.parse(value) : undefined;
    } catch {
        return undefined;
    }
}

export function disableCashReceipt(state: WritableDraft<CreateOrderRequest>) {
    state.cashReceipt = undefined;
}

export function setCashReceiptError(
    state: WritableDraft<CreateOrderRequest>,
    action: PayloadAction<string>,
) {
    state.cashReceiptError = action.payload;
}

export function clearCashReceiptError(state: WritableDraft<CreateOrderRequest>) {
    state.cashReceiptError = undefined;
}

export function setCashReceiptIssueType(
    state: WritableDraft<CreateOrderRequest>,
    action: PayloadAction<CashReceiptIssueType>,
) {
    state.cashReceipt = {
        issueType: action.payload,
        issueNumber: '',
    };
}

export function setCashReceiptNo(state: WritableDraft<CreateOrderRequest>, action: PayloadAction<string>) {
    state.cashReceipt!.issueNumber = action.payload;
}
